<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="chap3">Feb. 14, Sat. Morning</p>
<p class="center">I Lied</p>
<p class="ind" style="margin-top:20px;">Two phone calls today. Your social calendar is just filling up, McCrae.</p>
<p class="ind">Sunny wants to go to the beach. Actually, she demanded you drive her (and Maggie and Dawn).</p>
<p class="ind">And…</p>
<p class="ind"><span class="underline">JAY</span> called.</p>
<p class="ind">He wants to talk. He still feels bad about what he said yesterday morning. Even after his “apology,” he thinks you’re mad at him. (I WONDER where he gets THAT idea?) So you’re supposed to meet him at the Palo City Diner at 6.</p>
<p class="ind">You said you’d get back to him.</p>
<p class="ind">What if it’s a trick? What if he plans to bring along a gang of Cro Mags? He’s VERY tight with them.</p>
<p class="ind">Would he do that?</p>
<p class="ind">People don’t change THAT much, do they?</p>
<p class="ind">Whoa. Ease up.</p>
<p class="ind">You know, McCrae, you are one harsh creature. He DID apologize. He is reaching out to you.</p>
<p class="ind">He is TRYING to be friends again.</p>
<p class="ind">You scribble away in your journal, trashing one of your best friends, calling him a Cro Mag, making fun of him when he tries to say he’s sorry, and what’s he doing?</p>
<p class="ind">Planning ways to make you feel better.</p>
<p class="ind">So Jay’s crude. Big deal. You’ve always known that about him. But he’s always had that big heart too. Imagine if he hadn’t stood up for you back in 7th grade when Sal Mignona was beating you to a pulp. You’d be dead by now.</p>
<p class="ind">Face it. He hasn’t really changed. He’s the same guy you used to like. So what if he’s discovered girls. And hair gel. And cologne. And free weights.</p>
<p class="ind">He’ll get over it.</p>
<p class="ind" style="margin-top:20px;">Thought of the day: Jay is the opposite of Alex. One has faded. The other has intensified.</p>
<p class="ind">De-Alexation. Ultra-Jasification.</p>
<p class="ind">Too bad they can’t rub off on each other.</p>
<p class="ind" style="margin-top:20px;">Anyway, you have to stay friends with both of them. It’s not like the whole sophomore class is breaking down your door to be friends.</p>
<p class="ind">So call Jay back. Tell him you’ll meet him at the diner.</p>
<p class="ind">Besides, consider the alternative. Ted brought home a can of spam and a loaf of day-old Wonder Bread for dinner.</p>
<p class="ind">It’s a no-brainer.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6chap3.vue?5bc8e61e